import fr from './fr.json';

export const resources = { fr };
export const languages = { fr: 'fr' };
